import React from 'react';
import './EmailSkeleton.css';

/**
 * Skeleton for individual email list items.
 * Used in EmailList.jsx while a folder is loading.
 */
export const EmailListSkeleton = ({ count = 8 }) => (
    <>
        {Array.from({ length: count }).map((_, i) => (
            <div key={i} className="email-sk-list-item">
                <div className="email-sk-item-header-row">
                    <div
                        className="email-sk email-sk-from"
                        style={{ width: `${55 + (i % 4) * 8}%`, animationDelay: `${i * 0.06}s` }}
                    />
                    <div
                        className="email-sk email-sk-date"
                        style={{ animationDelay: `${i * 0.06 + 0.1}s` }}
                    />
                </div>
                <div
                    className="email-sk email-sk-subject"
                    style={{ width: `${65 + (i % 3) * 9}%`, animationDelay: `${i * 0.06 + 0.05}s` }}
                />
                <div
                    className="email-sk email-sk-snippet"
                    style={{ width: `${50 + (i % 5) * 7}%`, animationDelay: `${i * 0.06 + 0.08}s` }}
                />
            </div>
        ))}
    </>
);

/**
 * Skeleton for the email preview panel content.
 * Used in EmailPreview.jsx while a single email is loading.
 */
export const EmailPreviewSkeleton = () => (
    <>
        <div className="email-sk-pv-header">
            <div className="email-sk email-sk-pv-subject" />
            <div className="email-sk-pv-meta">
                <div className="email-sk email-sk-pv-avatar" />
                <div className="email-sk-pv-info">
                    <div className="email-sk email-sk-pv-name" />
                    <div className="email-sk email-sk-pv-to" />
                </div>
                <div className="email-sk-pv-actions">
                    {[0, 1, 2, 3].map((i) => (
                        <div
                            key={i}
                            className="email-sk email-sk-pv-action"
                            style={{ animationDelay: `${i * 0.08}s` }}
                        />
                    ))}
                </div>
            </div>
        </div>
        <div className="email-sk-pv-body">
            {[92, 85, 100, 70, 88, 55, 78, 42, 65, 30].map((w, i) => (
                <div
                    key={i}
                    className="email-sk email-sk-pv-line"
                    style={{ width: `${w}%`, animationDelay: `${i * 0.05}s` }}
                />
            ))}
        </div>
    </>
);

/**
 * Full 3-panel skeleton for the email section initial load.
 * Mirrors the sidebar + list + preview layout exactly.
 * Shown in EmailSection.jsx while accounts are being fetched.
 */
export const EmailSectionSkeleton = () => (
    <div className="email-layout">

        {/* ── Sidebar ─────────────────────────────────────────── */}
        <div className="email-sidebar">
            <div className="email-sidebar-header">
                {/* Account selector + add button */}
                <div className="email-sidebar-controls">
                    <div className="email-sk email-sk-account-select" />
                    <div className="email-sk email-sk-add-btn" />
                </div>
                {/* Compose button */}
                <div className="email-sk email-sk-compose-btn" />
            </div>

            {/* Folder list */}
            <div className="email-folder-list">
                {[82, 58, 70, 48, 74, 62].map((w, i) => (
                    <div key={i} className="email-sk-folder-row">
                        <div
                            className="email-sk email-sk-folder-icon"
                            style={{ animationDelay: `${i * 0.06}s` }}
                        />
                        <div
                            className="email-sk email-sk-folder-label"
                            style={{ width: `${w}%`, animationDelay: `${i * 0.06 + 0.05}s` }}
                        />
                    </div>
                ))}
            </div>

            {/* Sync button footer */}
            <div className="email-sidebar-footer">
                <div className="email-sk email-sk-sync-btn" />
            </div>
        </div>

        {/* ── List panel ──────────────────────────────────────── */}
        <div className="email-list-panel">
            <div className="email-list-header">
                <div className="email-sk email-sk-search-bar" />
                <div className="email-sk email-sk-refresh-btn-sk" />
            </div>
            <div className="email-list">
                <EmailListSkeleton count={8} />
            </div>
        </div>

        {/* ── Preview panel ───────────────────────────────────── */}
        <div className="email-preview-panel">
            <EmailPreviewSkeleton />
        </div>
    </div>
);
